import { fetchProjectDataTrees } from './dataTreesActions';

export const PARTICIPATIONS_TAG = 'Participations';

export const uploadFileToSessionParticipation = (
  participationId,
  equipmentFileId,
  file,
  successCallback,
  errorCallback
) => {
  return async (dispatch, getState, { apiClient }) => {
    const file_extension = file.name.slice(((file.name.lastIndexOf('.') - 1) >>> 0) + 2);
    const file_name = file.name.replace(/\.[^/.]+$/, '');

    const payload = {
      file,
      file_name,
      file_extension,
      file_description_id: equipmentFileId
    };
    try {
      await apiClient.call(
        PARTICIPATIONS_TAG,
        'uploadParticipationFile',
        { participationId },
        payload
      );

      successCallback && successCallback();
    } catch (e) {
      errorCallback && errorCallback(e);
    }

    dispatch(fetchProjectDataTrees(getState().projects.single.active.id));
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/participationsActions.js